import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"

export default function () {
    const { prev, first, pages, last, next } = usePagination({
        width: 5,
    })
    const { updateSearch } = useActions()

    function setPageCallback({ from }) {
        return () => {
            updateSearch({ products: { from } })
            scrollTo(0, 0)
        }
    }

    return (
        <>
            {pages.length > 1 && (
                <ul class="ns-pagination ns-d-flex ns-flex-wrap ns-justify-content-center ns-list-unstyled ns-m-0 ns-p-0 ns-my-2 ns-mx-0">
                    {prev && (
                        <li style="background: white">
                            <a
                                class="ns-page-link ns-previous ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3"
                                href="javascript:void(0)"
                                aria-label="Previous"
                                onClick={setPageCallback(prev)}
                            >
                                <span aria-hidden="true">
                                    <i class="ns-icon ns-icon-arrow"></i>
                                </span>
                            </a>
                        </li>
                    )}
                    {first && (
                        <li>
                            <a
                                class="ns-page-link ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3"
                                href="javascript:void(0)"
                                onClick={setPageCallback(first)}
                            >
                                {first.page}
                            </a>
                        </li>
                    )}

                    {first && (
                        <li>
                            <span class="ns-d-block ns-py-2 ns-px-4">...</span>
                        </li>
                    )}

                    {pages.map(page => (
                        <>
                            <li
                                class={`${page.current
                                        ? "ns-active ns-color-black"
                                        : ""
                                    }`}
                            >
                                <a
                                    class="ns-page-link ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3"
                                    href="javascript:void(0)"
                                    onClick={setPageCallback(page)}
                                >
                                    {page.page}
                                </a>
                            </li>
                        </>
                    ))}
                    {last && (
                        <li>
                            <span class="ns-py-2 ns-px-4">...</span>
                        </li>
                    )}
                    {last && (
                        <li>
                            <a
                                class="ns-page-link ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3"
                                href="javascript:void(0)"
                                onClick={setPageCallback(last)}
                            >
                                {last.page}
                            </a>
                        </li>
                    )}
                    {next && (
                        <li style="background: white">
                            <a
                                class="ns-page-link ns-next ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3"
                                href="javascript:void(0)"
                                aria-label="Next"
                                onClick={setPageCallback(next)}
                            >
                                <span aria-hidden="true">
                                    <i class="ns-icon ns-icon-arrow"></i>
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
            )}
        </>
    )

}
